import React from "react";
import { motion } from "framer-motion";
import {  Col, Button } from "react-bootstrap";
import ReportCard from "../../components/micheal/ReportCard";
import UserBarChart from "../../components/micheal/UserReport/UserBarChart";
import { MdOutlinePayments } from "react-icons/md";   
import { FaMinusCircle } from "react-icons/fa";       
import { FaWallet } from "react-icons/fa";            
import { GiReceiveMoney } from "react-icons/gi";   
import PayslipTable from "../../components/micheal/PaySlipReport/PayslipTable";


function PaySlipReport() {
  const stats = [
    {
      title: "Total Payroll",
      value: 250000,
      progress: 80,
      icon: MdOutlinePayments,
      color: "#28a745",
    },
    {
      title: "Deductions",
      value: 50000,
      progress: 45,
      icon: FaMinusCircle,
      color: "#ffc107",
    },
    {
      title: "Net Pay",
      value: 200000,
      progress: 60,
      icon: FaWallet,
      color: "#dc3545",
    },
    {
      title: "Allowances ",
      value: 30000,
      progress: 35,
      icon: GiReceiveMoney,
      color: "#0d6efd",
    },
  ];

  const data = [
  { month: "Jan", active: 30, inactive: 10 },
  { month: "Feb", active: 50, inactive: 20 },
  { month: "Mar", active: 60, inactive: 15 },
  { month: "Apr", active: 15, inactive: 5 },
  { month: "May", active: 40, inactive: 10 },
  { month: "Jun", active: 75, inactive: 20 },
  { month: "Jul", active: 30, inactive: 8 },
  { month: "Aug", active: 5, inactive: 2 },
  { month: "Sep", active: 65, inactive: 18 },
  { month: "Oct", active: 40, inactive: 12 },
  { month: "Nov", active: 55, inactive: 15 },
  { month: "Dec", active: 45, inactive: 10 },
];


  const payslipData = [
  {
    name: "Antony Lewis",
    role: "Web Designer",
    amount: "50,000",
    date: "14 Jan 2024",
    month: "May",
    year: "2025",
    avatar: "https://i.pravatar.cc/40?img=1",
  },
  {
    name: "Antony",
    role: "Web Designer",
    amount: "50,000",
    date: "14 Jan 2024",
    month: "May",
    year: "2025",
    avatar: "https://i.pravatar.cc/40?img=1",
  },
  {
    name: "Lewis",
    role: "Web Designer",
    amount: "50,000",
    date: "14 Jan 2024",
    month: "May",
    year: "2025",
    avatar: "https://i.pravatar.cc/40?img=1",
  },
  {
    name: "Antony Lewis",
    role: "Web Designer",
    amount: "50,000",
    date: "14 Jan 2024",
    month: "May",
    year: "2025",
    avatar: "https://i.pravatar.cc/40?img=1",
  },
  {
    name: "Antony Lewis",
    role: "Web Designer",
    amount: "50,000",
    date: "14 Jan 2024",
    month: "May",
    year: "2025",
    avatar: "https://i.pravatar.cc/40?img=1",
  },{
    name: "Antony Lewis",
    role: "Web Designer",
    amount: "50,000",
    date: "14 Jan 2024",
    month: "May",
    year: "2025",
    avatar: "https://i.pravatar.cc/40?img=1",
  },
];

  return (
    <div className="container-fluid mt-3">

      {/* HEADER */}
      <div className="d-flex mb-3">
        <h4 className="mb-0">PaySlip Report</h4>

        <Button className="ms-auto" variant="dark" size="sm">
          Export
        </Button>
      </div>

      {/* CARDS + CHART */}
      <motion.div className="row mb-3">
        <Col md={6}>
          <ReportCard stats={stats} />
        </Col>

        <Col md={6}>
          <UserBarChart data={data} />
        </Col>
      </motion.div>

      {/* TABLE */}
      <PayslipTable data={payslipData} />
    </div>
  );
}

export default PaySlipReport;